module.exports = __webpack_public_path__ + "images/53505bc7869613936da2dfda933ed555e1685c894cf64e3bef620e174d2518ee.svg";